export const environment = {
  production: false,
  apiUrl: 'https://comstest.habiboil.com/ords/cots/api/v1/',
  oathTokeUrl: 'https://comstest.habiboil.com/ords/cots/oauth/token?',
  // apiUrl: 'http://10.0.0.15:8080/ords/cots/api/v1/',
  // oathTokeUrl: 'http://10.0.0.15:8080/ords/cots/oauth/token?',
};
